import {LoomServices} from "./LoomServices";
export const loomServices = new LoomServices();

export type {LoomServices}
export type {LoomServicesConfig} from "./LoomServicesConfig"
export type {AuthConfig, AuthContext, RealmConfig, RestoreRouteFunction} from "loom-auth-service";
